// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    HcpIntakeRequestModel,
    IntakeIntakeHcpIntakeDefaultResponse,
    IntakeIntakeIsHcpIntakeAllowedDefaultResponse,
    IntakeIntakePatientIntakeDefaultResponse,
    IntakeIntakeSimpleIntakeDefaultResponse,
    IsHcpIntakeAllowedRequestModel,
    PatientIntakeRequestModel,
    SimpleIntakeRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeIntakeApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param hcpIntakeRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async intakeHcpIntake (hcpIntakeRequestModel: HcpIntakeRequestModel, xProgramId?: string): Promise<AxiosResponse<IntakeIntakeHcpIntakeDefaultResponse>> {
        const _url_ = '/edge/intake/HcpIntake';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'hcpIntakeRequestModel' is not null or undefined
        if (hcpIntakeRequestModel === null || hcpIntakeRequestModel === undefined) {
            throw new Error('Required parameter hcpIntakeRequestModel was null or undefined when calling intakeHcpIntake.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(hcpIntakeRequestModel, "HcpIntakeRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<IntakeIntakeHcpIntakeDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IntakeIntakeHcpIntakeDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param isHcpIntakeAllowedRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async intakeIsHcpIntakeAllowed (isHcpIntakeAllowedRequestModel: IsHcpIntakeAllowedRequestModel, xProgramId?: string): Promise<AxiosResponse<IntakeIntakeIsHcpIntakeAllowedDefaultResponse>> {
        const _url_ = '/edge/intake/IsHcpIntakeAllowed';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'isHcpIntakeAllowedRequestModel' is not null or undefined
        if (isHcpIntakeAllowedRequestModel === null || isHcpIntakeAllowedRequestModel === undefined) {
            throw new Error('Required parameter isHcpIntakeAllowedRequestModel was null or undefined when calling intakeIsHcpIntakeAllowed.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(isHcpIntakeAllowedRequestModel, "IsHcpIntakeAllowedRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<IntakeIntakeIsHcpIntakeAllowedDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IntakeIntakeIsHcpIntakeAllowedDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param patientIntakeRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async intakePatientIntake (patientIntakeRequestModel: PatientIntakeRequestModel, xProgramId?: string): Promise<AxiosResponse<IntakeIntakePatientIntakeDefaultResponse>> {
        const _url_ = '/edge/intake/PatientIntake';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientIntakeRequestModel' is not null or undefined
        if (patientIntakeRequestModel === null || patientIntakeRequestModel === undefined) {
            throw new Error('Required parameter patientIntakeRequestModel was null or undefined when calling intakePatientIntake.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientIntakeRequestModel, "PatientIntakeRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<IntakeIntakePatientIntakeDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IntakeIntakePatientIntakeDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param simpleIntakeRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async intakeSimpleIntake (simpleIntakeRequestModel: SimpleIntakeRequestModel, xProgramId?: string): Promise<AxiosResponse<IntakeIntakeSimpleIntakeDefaultResponse>> {
        const _url_ = '/edge/intake/SimpleIntake';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'simpleIntakeRequestModel' is not null or undefined
        if (simpleIntakeRequestModel === null || simpleIntakeRequestModel === undefined) {
            throw new Error('Required parameter simpleIntakeRequestModel was null or undefined when calling intakeSimpleIntake.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(simpleIntakeRequestModel, "SimpleIntakeRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<IntakeIntakeSimpleIntakeDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IntakeIntakeSimpleIntakeDefaultResponse");
        }
        return response;
    }
}
